<mat-nav-list>
  <mat-list-item>
    <a matRipple class="user-section" [routerLink]="{ url: accountInfoUrl } | dsLibMainMenuRouterLink">
      <ds-lib-profile-bar
        class="byd-profile-bar"
        [mainInfo]="user?.firstname + ' ' + user?.lastname"
        [subInfo]="user?.login"
        (logout)="onLogout()"
        [isExpanded]="isExpanded"
      >
      </ds-lib-profile-bar>
    </a>
  </mat-list-item>
  <!-- Display the tabs only if there are more than one tab -->
  <div class="tabs-div" *ngIf="tabs.length > 1">
    <!-- List of tabs, emits object to parent element on click -->
    <a
      *ngFor="let tab of tabs"
      class="ds-lib-main-menu-tab"
      (click)="selectTab(tab)"
      [ngClass]="{ active: tab.id === selectedTabId }"
      matRipple
    >
      <mat-icon>{{ tab.icon }}</mat-icon>
      <p>{{ tab.id === selectedTabId ? tab.title : '' }}</p>
    </a>
  </div>
  <ng-template ngFor let-tab [ngForOf]="tabs">
    <ng-template [ngIf]="tab.id === selectedTabId">
      <!-- select start -->
      <ds-lib-dropdown-list
        [tab]="tab"
        [isExpanded]="isExpanded"
        (selectItemClick)="onSelectItemClicked($event)"
        (click)="expandMenu()"
      >
      </ds-lib-dropdown-list>
      <!-- select end -->
      <ds-lib-section
        [isExpanded]="isExpanded"
        [tab]="tab"
        [fontSize]="titleFontSize"
        [rights]="rights"
        (sectionClicked)="onSectionClicked($event)"
      >
      </ds-lib-section>
    </ng-template>
  </ng-template>
  <ds-lib-disconnect-button [isExpanded]="isExpanded" [fontSize]="titleFontSize" (logout)="onLogout()">
  </ds-lib-disconnect-button>
  <mat-list-item *ngIf="productLogos" [ngClass]="['menu-logs', isExpanded ? 'expanded' : 'reduced']">
    <img
      [ngClass]="[isExpanded ? 'expanded' : 'reduced']"
      [src]="isExpanded ? productLogos.expanded : productLogos.reduced"
    />
  </mat-list-item>
</mat-nav-list>
<!-- Ensures the z-index of the menu toggle is higher than profile bar. -->
<div mat-list-item class="menu-toggle" matRipple (click)="toggleMenuExpand()">
  <mat-icon *ngIf="!isExpanded">arrow_right</mat-icon>
  <mat-icon *ngIf="isExpanded">arrow_left</mat-icon>
</div>
